

































































































































import IListPalletType from '@/store/models/IListPalletType';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';

@Component({
    components: {
        Snackbar
    }
})
export default class ListPalletTypesSelector extends Vue {
    searchListPalletTypes: string = "";
    dialog: boolean = false;
    isValid: boolean = true;
    sortBy: string = 'name';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Name', value: 'name' },
        { text: 'Not billable', value: 'notBillable' },
        { text: 'Actions', value: 'actions', sortable: false }
    ];
    editedIndex : number = -1;
    editedItem : IListPalletType = {
        id: "",
        name: "",
        notBillable: false
    }
    defaultItem : IListPalletType = {
        id: "",
        name: "",
        notBillable: false
    }

    @Prop({ type: Array, required: true })
    ListPalletTypesList !: IListPalletType[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];

    selectedListPalletTypes : IListPalletType[] = [];

    get formTitle() { return this.editedIndex === -1 ? 'New Pallet Type' : 'Edit Pallet Type'; }

    @Watch('dialog')
    onDialogChanged(val: any) {
        val || this.close();
    }

    resetListPalletTypes() {
        this.selectedListPalletTypes = [];
    }

    editListPalletType (item: any, dbox = true) {
        this.editedIndex = this.ListPalletTypesList.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
    }

    editNotBillableTypePallet(item: IListPalletType) {
        this.$emit('editListPalletType', item);
    }

    saveListPalletType () {
        if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
            if (this.editedIndex > -1 || this.selectedListPalletTypes[0]) {
                this.close();
                this.$emit('editListPalletType', this.editedItem);
                Object.assign(this.ListPalletTypesList[this.editedIndex], this.editedItem);
            } else {
                this.selectedListPalletTypes[0] = this.editedItem;
                this.$emit('saveListPalletType', this.editedItem);
            }
            this.close();
        } else {
            this.$emit('showMessageWarning', 'All required fields must be filled out');
        }
    }

    deleteListPalletType (palletType: IListPalletType) {
        this.$emit('deleteListPalletType', palletType);
        this.close();
    }

    close() : void {
        this.dialog = false;
        this.$nextTick(() => {
            this.editedItem = Object.assign({}, this.defaultItem);
            this.editedIndex = -1;
        });
    }

    selectListPalletTypes(item : any) : void {
        if (!this.selectedListPalletTypes.includes(item)) {
            this.selectedListPalletTypes = [];
            this.selectedListPalletTypes = [item];
        } else {
            this.selectedListPalletTypes = [];
        }
    }
    
    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
